module.exports = __webpack_public_path__ + "a5483a5f2dd4549617f3131234a08be1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/spaceship.png
// module id = 2884
// module chunks = 0